import wxsdk from './wxconfig';
var config = require('../../../config/api.config');
var url = config.host + '/m/hudong-h5/#/index/list';
var _window = window;
_window.wx = '';
export default {
    appLink: 'kdweidian://weidian.com?type=4&url=' + encodeURIComponent(url),
    initWXSDK: function() {
        var _this = this;
        wxsdk({
            cb: function() {
                _window.wx = wx;
                _this.launchApp();
            },
            apiList: ['launch3rdApp','getInstallState']
        });
    },
    launchApp: function() {
        // 在微信中，调用微信jssdk打开APP
        _window.wx.invoke('launch3rdApp', {
            'appID': 'wx2e5df03e8b9c6525', // 微店
            'messageExt': this.appLink,
            'extInfo': this.appLink
        }, function(e) {
            var errMsg = e.err_msg||e.errMsg;
            if(errMsg.indexOf('launch_3rdApp:ok') < 0) {
                // 唤起APP失败，跳转到下载页
                location.href = '//m.weidian.com/';
            }
        })
    },
    openApp: function() {
        let ua = _window.navigator.userAgent;
        if(/MicroMessenger/i.test(ua)) {
            if(_window.wx) {
                this.launchApp();
            } else {
                this.initWXSDK();
            }
        } else {
            location.href = this.appLink;
            setTimeout(function() {
                location.href = '//m.weidian.com/';
            }, 2000);
        }
        // e.stopPropagation();
        // e.preventDefault();
        // return false;
    }
}


/** WEBPACK FOOTER **
 ** ./common/js/wxsdk.js
 **/